import { render, staticRenderFns } from "./AppCard.vue?vue&type=template&id=a52fcfc6&scoped=true&"
import script from "./AppCard.vue?vue&type=script&lang=js&"
export * from "./AppCard.vue?vue&type=script&lang=js&"
import style0 from "./AppCard.vue?vue&type=style&index=0&id=a52fcfc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52fcfc6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a52fcfc6')) {
      api.createRecord('a52fcfc6', component.options)
    } else {
      api.reload('a52fcfc6', component.options)
    }
    module.hot.accept("./AppCard.vue?vue&type=template&id=a52fcfc6&scoped=true&", function () {
      api.rerender('a52fcfc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/AppCard.vue"
export default component.exports